import React, { Component } from "react";
import { DataGrid, GridRowsProp, GridColDef, GridLoadingOverlay } from '@mui/x-data-grid';
import { DataGridPro } from '@mui/x-data-grid-pro';
import Paper from '@mui/material/Paper';
import { v4 as uuidv4 } from 'uuid';
import Avatar from '@mui/material/Avatar';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import AssistantPhotoIcon from '@mui/icons-material/AssistantPhoto';
import Button from '@mui/material/Button';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import Grid from '@mui/material/Grid';
import Pagination from "@mui/material/Pagination";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import SentimentSatisfiedAltOutlinedIcon from '@mui/icons-material/SentimentSatisfiedAltOutlined';
import SentimentDissatisfiedOutlinedIcon from '@mui/icons-material/SentimentDissatisfiedOutlined';

import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DialogAide from "./DialogAide";


import {
  gridPageCountSelector,
  gridPageSelector,
  useGridApiContext,
  useGridSelector
} from "@mui/x-data-grid";

export default class TableauRentabilite extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data:this.props.data,
      aide:false
    };
    
  }

  componentWillReceiveProps(props) {
    this.setState({ data: props.data})
  }

  componentDidMount() {
  }

  openAide = () => {
    this.setState({ aide: true})
  }

  closeAide = () => {
    this.setState({ aide: false})
  }

  /************************************************************************************
   * RENDU
   ***********************************************************************************/

  render() {

    function format(data){
      data = Number(data);
      return data.toLocaleString('fr-FR');
    }

    function rde(data){
      var d = data;
      data = data.rendementGagnant;
      
      if(data >= -5 && data < 0){
        return (
          <div style={{display:"flex", float:"right"}}>
          <div>
            <span class="lato-regular">{format(d.gainGagnant)} €</span> 
          </div>
          <div style={{marginLeft:"2em"}}>
          <span class="lato-regular">{data} %</span>
          </div>
          <div style={{marginLeft:"1em", marginTop:"-0.2em"}}>
          <SentimentDissatisfiedOutlinedIcon color="warning" />
          </div>
          </div>
        )
      }else if(data < -5){
        return (
          <div style={{display:"flex", float:"right"}}>
            <div>
            <span class="lato-regular">{format(d.gainGagnant)} €</span>  
          </div>
          <div style={{marginLeft:"2em"}}>
          <span class="lato-regular">{data} %</span>
          </div>
          <div style={{marginLeft:"1em", marginTop:"-0.2em"}}>
          <SentimentDissatisfiedOutlinedIcon color="error" />
          </div>
          </div>
        )
      }
      
      else if(data >= 0){
        return (
          <div style={{display:"flex", float:"right"}}>
            <div>
            <span class="lato-regular">{format(d.gainGagnant)} €</span>
          </div>
          <div style={{marginLeft:"2em"}}>
          <span class="lato-regular">{data} %</span>
          </div>
          <div style={{marginLeft:"1em", marginTop:"-0.2em"}}>
          <SentimentSatisfiedAltOutlinedIcon color="success" />
          </div>
          </div>
        )
      }
    }

    return(
      <div >
    {this.state.aide && (
    <DialogAide titre={"Astuce"} open={true} 
    close={this.closeAide}
    content={<span class="lato-regular">Ce tableau présente le calcul du gain / perte (simple gagnant) en jouant sur l’ensemble des chevaux sélectionnés (en masse égale, 1€ par mise). Cela signifie que si la sélection donne 3 chevaux, alors 3 paris sont simulés pour cette course, un sur chaque cheval.
    <br/><br/>Donne une vision exhaustive des performances de la sélection.</span>}
    />
    )}

      <Table component={Paper}>
        <TableHead>
          <TableRow>
            <TableCell><span class="lato-bold">Gain global SG</span></TableCell>
            <TableCell>

            <IconButton aria-label="settings" style={{float:"right"}}>
              <Tooltip title={<span class="lato-regular">Aide</span>}>
                <HelpOutlineOutlinedIcon onClick={this.openAide} style={{color:"black", cursor:"pointer"}}/>
              </Tooltip>
          </IconButton>

            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          
            <TableRow>
              <TableCell width={"65%"} align="left"><span class="lato-regular">Gain :</span></TableCell>
              <TableCell> {rde(this.state.data.analyse)}</TableCell>
            </TableRow>
            
        </TableBody>
      </Table>
      </div>
    )
  }
}